// Celebration sparkle for OpenEd-state correct answers.
// Pure CSS animation — no dependencies. Re-keyed so each burst replays.

const COLORS = [
  '#C8932B', // gold
  '#2C7BC4', // opened blue
  '#3D7A4A', // correct green
  '#A33333', // terracotta
  '#1A2238', // ink
];

export default function ConfettiBurst({ count = 24 }) {
  const particles = Array.from({ length: count }, (_, i) => {
    const angle = (Math.PI * 2 * i) / count + Math.random() * 0.4;
    const distance = 80 + Math.random() * 120;
    return {
      id: i,
      tx: Math.cos(angle) * distance,
      ty: Math.sin(angle) * distance * 0.9 - 30,
      delay: Math.random() * 0.08,
      duration: 0.9 + Math.random() * 0.6,
      rotate: Math.random() * 720 - 360,
      color: COLORS[i % COLORS.length],
      scale: 0.7 + Math.random() * 0.7,
      shape: i % 3, // 0: rect, 1: square, 2: circle
    };
  });

  return (
    <div className="confetti-layer" aria-hidden="true">
      {particles.map(p => (
        <span
          key={p.id}
          className={`confetti-piece shape-${p.shape}`}
          style={{
            '--tx': `${p.tx}px`,
            '--ty': `${p.ty}px`,
            '--rot': `${p.rotate}deg`,
            '--scale': p.scale,
            '--delay': `${p.delay}s`,
            '--duration': `${p.duration}s`,
            background: p.color,
          }}
        />
      ))}
    </div>
  );
}
